import type { ColumnProps } from '#/common/components/DataGrid';

const columns: ColumnProps<Record<string, string>>[] = [
  // Mandatory columns
  {
    dataField: 'asset_tag',
    caption: 'Asset Tag',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'serial_number',
    caption: 'Serial Number',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'status',
    caption: 'Status',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'asset_type',
    caption: 'Asset Type',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'manufacturer',
    caption: 'Manufacturer',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'model',
    caption: 'Model',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'description',
    caption: 'Description',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'location_path',
    caption: 'Location',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },

  // Optional columns
  {
    dataField: 'install_date',
    caption: 'Install Date',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'condition',
    caption: 'Condition',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'acquisition_cost_value',
    caption: 'Acquisition Cost',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'maintenance_cost_value',
    caption: 'Maintenance Cost',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'useful_life',
    caption: 'Useful Life (In Years)',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
];

export default columns;
